import React from 'react';
import classnames from 'classnames';
import { Portal } from '../portal';
import './overlay.scss';
export const Overlay = ({ className, show = false, blur = 0, opacity = 100, fullscreen = false, animate = false, zIndex = 20, children, }) => {
    const overlayClassName = classnames('overlay', className, {
        'overlay--show': show && !animate,
        'overlay--enter': show && animate,
        'overlay--leave': !show && animate,
    });
    const overlayShadowStyles = {
        background: `rgba(34, 43, 53, ${opacity / 100})`,
    };
    if (blur) {
        overlayShadowStyles.backdropFilter = `blur(${blur}px)`;
    }
    const overlay = (<div className={overlayClassName} style={{ zIndex }}>
      <div className="overlay__shadow" style={overlayShadowStyles}/>
      <div className="overlay__content">{children}</div>
    </div>);
    return fullscreen ? <Portal>{overlay}</Portal> : overlay;
};
